export default class EditorModule {
    constructor(editor) {
        this.editor = editor;
    }
    unload() { }
    finishLoading() { }
    input() { }
    assetCreated(assetElement, asset = undefined) { }
    assetsCreated(allAssetElements) { }
    assetActivationChanged(asset, active) { }
    assetCompletionChanged(asset, completed, onCommitCompleted) { }
    assetCompletabilityChanged(asset) { }
    assetInstanceLockChanged(asset, locked) { }
    assetInstanceCompletionChanged(asset, completed) { }
    assetRefreshed(asset) { }
    assetCompletable(asset) { return true; }
    subassetCreated(subAsset) { }
    progressChanged(progress) { }
    selectionChanged() { }
    keyDown(event) { }
    keyDownComplete(event) { }
    keyPress(event) { }
    clipboardEvent(event) { }
    clearSearchPhrase() { }
    assetChanged(asset) { }
}
